import { Component } from '@builder.io/sdk';
import { MarginField, AnchorField } from '@/components/BuilderIO/common/CommonFields';
import colors from '@/styles/colors';

const globalSlimlinePromotionBanners: { tabName: string; path: string; components: Record<string, Component> } = {
  tabName: 'Slimline Promotion Banners',
  path: 'slimlinePromotionBanners',
  components: {
    HeaderBanner: {
      name: 'Header Banner',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F9f2a69003c86470ea05deb9ecb9887be%2Fab16f132401146929e2f88328a6826c3',
      inputs: [
        {
          name: 'backgroundColor',
          type: 'color',
          defaultValue: '#a95490',
        },
        {
          name: 'fontColor',
          type: 'color',
        },
        MarginField,
        AnchorField,
        {
          name: 'gaEvents',
          type: 'list',
          subFields: [
            {
              name: 'dataAttributes',
              type: 'list',
              subFields: [
                {
                  name: 'dataAttributeName',
                  type: 'text',
                },
                {
                  name: 'dataAttributeValue',
                  type: 'text',
                },
              ],
            },
          ],
        },
      ],
    },
    SlimlinePromotionBanner: {
      name: 'Slimline Promotion Banner',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F9f2a69003c86470ea05deb9ecb9887be%2Fab16f132401146929e2f88328a6826c3',
      inputs: [
        {
          name: 'backgroundColor',
          type: 'color',
          defaultValue: colors['dark-green'].raw,
        },
        {
          name: 'fontColor',
          type: 'color',
          defaultValue: 'white',
        },
        MarginField,
        AnchorField,
        {
          name: 'gaEvents',
          type: 'list',
          subFields: [
            {
              name: 'dataAttributes',
              type: 'list',
              subFields: [
                {
                  name: 'dataAttributeName',
                  type: 'text',
                },
                {
                  name: 'dataAttributeValue',
                  type: 'text',
                },
              ],
            },
          ],
        },
      ],
    },
    RotatingPromotionBanner: {
      name: 'Rotating Promotion Banner',
      image:
        'https://cdn.builder.io/api/v1/image/assets%2F9f2a69003c86470ea05deb9ecb9887be%2Fab16f132401146929e2f88328a6826c3',
      inputs: [
        {
          name: 'backgroundColor',
          type: 'color',
          defaultValue: colors['dark-green'].raw,
        },
        {
          name: 'fontColor',
          type: 'color',
          defaultValue: 'white',
        },
        {
          name: 'messages',
          type: 'list',
          helperText: 'Only the first 3 items will appear',
          onChange: options => {
            if (options.get['messages'].length > 3) {
              options.set('messages', options.get('messages').slice(0, 3));
            }
          },
          subFields: [
            {
              name: 'text',
              type: 'richText',
            },
            {
              name: 'mobileText',
              type: 'richText',
            },
            {
              name: 'link',
              type: 'url',
            },
          ],
        },
        {
          name: 'PromoMessagePosition',
          type: 'text',
          helperText: 'The position in which the Promo Message will be inserted in the Messages list.',
          enum: ['1', '2', '3'],
          defaultValue: 1,
        },
        {
          name: 'gaEvents',
          type: 'list',
          subFields: [
            {
              name: 'dataAttributes',
              type: 'list',
              subFields: [
                {
                  name: 'dataAttributeName',
                  type: 'text',
                },
                {
                  name: 'dataAttributeValue',
                  type: 'text',
                },
              ],
            },
          ],
        },
        AnchorField,
      ],
    },
  },
};

export default globalSlimlinePromotionBanners;
